import initNav from './modules/nav';
import initCarousel from './modules/carousel';
import disableScrollX from './modules/disableScrollX';
import initMaintenanceLoadMore from './modules/maintenanceLoadMore';

initNav();
initCarousel();
disableScrollX();
initMaintenanceLoadMore();
